<template>
  <div class="color-value" :style="{backgroundColor: attr.value}"></div>
</template>

<script>
export default {
  props: ['attr']
}
</script>
